import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Button, ButtonDirective } from 'primeng/button';
import { MessageService } from 'primeng/api';
import { Toast } from 'primeng/toast';

@Component({
  selector: 'app-json-tree',
  imports: [
    CommonModule,
    Button,
    ButtonDirective,
    Toast
  ],
  providers: [MessageService],
  templateUrl: './json-tree.component.html',
  styleUrl: './json-tree.component.scss'
})
export class JsonTreeComponent {
  @Input() data: any;
  messageService = inject(MessageService);

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  isObject(value: any): boolean {
    return value && typeof value === 'object' && !Array.isArray(value);
  }

  copyJson() {
    const formatted = JSON.stringify(this.data, null, 2); // identado
    navigator.clipboard.writeText(formatted).then(() => {
      this.messageService.add({
        severity: 'success',
        summary: 'Json Copiado',
        detail: 'O Json foi copiado para área de transferência'
      })
    });
  }
}
